<script>
import 'vue-select/dist/vue-select.css'
import { axiosGetPost } from '@router/axiosGetPost'
import EditFailTransitTime from '@components/EditFailTransitTime'
import EditTransitTime from '@components/EditTransitTime'

export default {
  name: 'TransitTimeTable',
  components: {
    EditFailTransitTime,
    EditTransitTime,
  },
  props: {
    TableData: { type: [Object, Array], default: null },
    TypeTable: { type: String, default: null },
    incOptions: { type: Array, default: null },
  },
  data() {
    return {
      typeTable: this.TypeTable,
      inc_options: this.incOptions,
      loandingDataDpM: false,
      tableData: [{ data: 'ok' }],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: 'age',
      sortDesc: false,
      fields: [],
      fieldList: [{ key: 'data' }],
      excludeFields: [],
      modalComponent: null,
      modalTitle: 'Status',
      modalError: null,
      modalErrorShow: false,
      showModal: false,
      loadingData: false,
      isTesting: false,
      transitTimeId: null,
    }
  },
  computed: {
    /**
     * Total no. of records
     */

    rows() {
      return this.tableData.length
    },
  },
  created() {
    this.updateTableFields('SELECT')
    this.tableData = this.TableData[0]
    this.fieldList = this.TableData[1]
  },
  mounted() {
    this.$root.$emit('closeModal', () => {
      this.saveModal()
    })
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    customFilterTable(row, filter) {
      this.loadingDataDpM = false
      var valuesRow = Object.values(row)
      //console.log(values)
      let filtersSp = filter.split(' ')
      var flag = false
      const filtersFined = []
      filtersSp.forEach((filterVal) => {
        valuesRow.filter((valRow) => {
          var valRowLC = String(valRow).toLowerCase()
          var filterValLC = String(filterVal).toLowerCase()
          if (valRowLC.includes(filterValLC)) {
            if (!filtersFined.includes(filterVal)) filtersFined.push(filterVal)
          }
        })
      })

      if (filtersFined.length === filtersSp.length) {
        flag = true
      }

      if (flag === true) {
        return true
      } else {
        return false
      }
      this.loadingDataDpM = true
    },
    updateTableFields(action = 'SELECT') {
      if (action === 'SELECT') {
        axiosGetPost('post', 'settingU/', {
          modules: [this.typeTable + '_transit_times'],
        }).then((data) => {
          if (data.success === true) {
            this.excludeFields = data.data[this.typeTable + '_transit_times']
            this.orderFields()
          } else {
            this.$toastr.e('Error Load Exclude column Select' + data.error)
          }
          return data
        })
      } else if (action === 'UPDATE') {
        this.orderFields()
        axiosGetPost('put', 'settingU/', {
          modules: [
            {
              name: this.typeTable + '_transit_times',
              data: this.excludeFields,
            },
          ],
        }).then((data) => {
          if (data.success !== true) {
            this.$toastr.e('Error Load Exclude column Update' + data.error)
          }
          return data
        })
      }
    },
    orderFields() {
      this.fields = []
      for (var [key, value] of Object.entries(this.fieldList)) {
        if (!(this.excludeFields.indexOf(value.key) > -1)) {
          this.fields.push(this.fieldList[key])
        }
      }
    },
    editRow(id, module = 'editFailRow') {
      console.log(id)
      this.showModal = true
      this.loadingData = true
      this.modalComponent =
        module != 'editRow' ? 'EditFailTransitTime' : 'EditTransitTime'
      this.modalTitle =
        module != 'editRow' ? 'Edit Wrong Transit Time' : 'Edit Transit Time'
      this.transitTimeId = null
      this.transitTimeId = id
      this.loadingData = false
    },
    deleteRow(id) {
      this.$swal({
        title:
          'Are you sure you want to delete this transit time with ID ' +
          id +
          '? This action is irreversible.',
        showCancelButton: true,
        confirmButtonColor: 'brown',
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.value) {
          this.loadingData = true
          axiosGetPost('post', '/transit_times/delete', {
            id: id,
            mode: this.TypeTable,
          }).then((response) => {
            if (response.status) {
              this.$toastr.s('Success. Transit Time Deleted')
              this.$emit('update_table','transitt',['good','fail'])
            } else {
              this.$toastr.e('Attention. Error')
            }
            this.loadingData = false
            this.$root.$emit('closeModal')
            this.updateTableFields('SELECT')
            return response
          })
        } else {
          this.$swal('Cancelled')
        }
      })
    },
    saveModal() {
      this.showModal = false
    },
    functionEmit(typeT = []){
      this.$emit('update_table','transitt',typeT)
    },
  },
}
</script>

<template>
  <div>
    <div
      v-if="loandingDataDpM"
      class="row align-items-center justify-content-center"
      style="height: 300px"
    >
      <div class="col-12 col-md-8 text-center">
        <b-spinner
          label="Loading..."
          variant="secondary"
          class="ml-3"
        ></b-spinner>
      </div>
    </div>
    <div v-else>
      <div class="form-group row">
        <div class="col-md-12">
          <div class="d-flex mb-md-2">
            <!-- Inicio Table */******************************************************* */ -->
            <div class="mr-auto">
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center">
                  Show&nbsp;
                  <b-form-select
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select
                  >&nbsp;entries </label
                >&nbsp;&nbsp;
              </div>
            </div>
            <!-- Inicio Ocultar columnsas /********************/**************-->
            <div>
              <b-dropdown
                class="d-inline"
                variant="link"
                toggle-class="font-weight-bold p-0 align-middle"
              >
                <template v-slot:button-content>
                  Hide Columns
                  <i class="uil uil-eye-slash font-size-16 align-middle"></i
                  ><i class="uil uil-angle-down font-size-16 align-middle"></i>
                </template>
                <div v-for="(field, index) of fieldList" :key="index">
                  <div v-if="field.checkBox" class="dropdown-item">
                    <div class="col-lg-6 mb-2 mb-lg-0">
                      <div
                        :for="`field-${
                          index + '-' + typeTable + '_transit_times'
                        }`"
                        class="custom-control custom-checkbox"
                      >
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          :id="`field-${
                            index + '-' + typeTable + '_transit_times'
                          }`"
                          :value="field.key"
                          v-model="excludeFields"
                          @change="updateTableFields('UPDATE')"
                        />
                        <label
                          class="custom-control-label"
                          :for="`field-${
                            index + '-' + typeTable + '_transit_times'
                          }`"
                          >{{ field.label }}</label
                        >
                      </div>
                      <!-- end checkbox -->
                    </div>
                  </div>
                </div>
              </b-dropdown>
            </div>
            <!-- Fin Ocultar columnsas /********************/**************-->
            <!-- Search -->
            <div>
              <label class="d-inline-flex align-items-center">
                Search:
                <b-form-input
                  v-model="filter"
                  type="search"
                  placeholder="Search..."
                  class="form-control form-control-sm ml-2"
                ></b-form-input>
              </label>
            </div>

            <!-- End search -->
          </div>
          <!-- Table -->
          <div class="table-responsive mb-0">
            <b-table
              striped
              hover
              :items="tableData"
              :fields="fields"
              responsive="sm"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              :filter-function="customFilterTable"
              @filtered="onFiltered"
            >
              <template v-slot:cell(actions)="row">
                <b-dropdown
                  v-if="inc_options.length >= 1"
                  variant="success"
                  dropleft
                  class="ml-1 btn-sm"
                >
                  <template slot="button-content">
                    <i>Options</i>
                  </template>
                  <b-dropdown-item
                    href="#"
                    v-if="inc_options.includes('editFails')"
                    style="color: #0a399a"
                    @click="editRow(row.item.id)"
                  >
                    <span style="color: rgb(1 38 113)">
                      <i class="uil uil-edit"></i>
                      &nbsp; &nbsp;Edit
                    </span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    href="#"
                    v-if="inc_options.includes('edit')"
                    style="color: #0a399a"
                    @click="editRow(row.item.id, 'editRow')"
                  >
                    <span style="color: rgb(1 38 113)">
                      <i class="uil uil-edit"></i>
                      &nbsp; &nbsp;Edit
                    </span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    href="#"
                    v-if="inc_options.includes('delete')"
                    style="color: #0a399a"
                    @click="deleteRow(row.item.id)"
                  >
                    <span style="color: rgb(1 38 113)">
                      <i class="uil uil-trash-alt"></i>
                      &nbsp; &nbsp;Delete
                    </span>
                  </b-dropdown-item>
                </b-dropdown>
                <i v-else> -------- </i>
              </template>
            </b-table>
          </div>
          <div class="row">
            <div class="col">
              <strong>Filtered {{ totalRows }} of {{ rows }} entries</strong>
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>

          <!-- Fin Table */******************************************************* */ -->
        </div>
      </div>
    </div>
    <b-modal
      id="modal-lg"
      ref="requestFcl"
      v-model="showModal"
      size="lg"
      :title="modalTitle"
      title-class="font-18"
    >
      <div
        v-if="loadingData"
        class="row align-items-center justify-content-center"
        style="height: 300px"
      >
        <div class="col-12 col-md-8 text-center">
          <b-spinner
            label="Loading..."
            variant="primary"
            class="ml-3"
          ></b-spinner>
        </div>
      </div>

      <div v-else-if="modalErrorShow === true">
        <div
          class="row align-items-center justify-content-center"
          style="height: 300px"
        >
          <div class="col-12 col-md-8 text-center">
            <feather type="frown" class="icon-xxl icon-dual-info"></feather>
            <h6 class="text-muted">{{ modalError }}</h6>
          </div>
        </div>
      </div>

      <EditFailTransitTime
        v-if="modalComponent === 'EditFailTransitTime' && loadingData === false"
        :transit-time-id="transitTimeId" @update_table="functionEmit"
      />
      <EditTransitTime
        v-if="modalComponent === 'EditTransitTime' && loadingData === false"
        :transit-time-id="transitTimeId" @update_table="functionEmit"
      />

      <template v-slot:modal-footer>
        <b-button variant="light" @click="saveModal">Close</b-button>
        <!--        <b-button
          v-if="
            loadingData === false &&
            modalErrorShow === false &&
            modalComponent === 'searchRatesHistory'
          "
          variant="primary"
          @click="saveModal"
        >
          OK
        </b-button>-->
      </template>
    </b-modal>
  </div>
</template>
<style>
.table-responsive-list-menu {
  overflow-x: visible !important;
  overflow-y: visible !important;
}

.badge-soft-warning {
  color: #c39411 !important;
  background-color: rgba(255, 190, 11, 0.2);
}

.badge-soft-success {
  color: #299a70 !important;
  background-color: rgba(67, 211, 158, 0.2);
}

.badge-soft-info {
  color: #259cb5 !important;
  background-color: rgba(37, 194, 227, 0.2);
}

.badge-soft-pdp {
  color: #a243d3 !important;
  background-color: rgb(162 67 211 / 20%);
}

.badge-tier-1 {
  color: #ffffff !important;
  background-color: #1f56d6;
}

.badge-tier-2 {
  color: #ffffff !important;
  background-color: #1f93d6;
}

.badge-tier-3 {
  color: #ffffff !important;
  background-color: #1dbfd7;
}

.btn-success:hover {
  color: #010b55;
  background-color: #e9e9e9;
  border-color: #001add;
}

.btn-success {
  color: #0014a2;
  background-color: #ffffff;
  border-color: #031b4e;
}

.show .btn-success.dropdown-toggle {
  color: #010b55;
  background-color: #e9e9e9;
  border-color: #001add;
}

.text {
  font-family: helvetica;
  font-weight: bold;
  color: #71d90b;
}
</style>